import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';

const EmptyValue = styled.div`
  height: 100%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border-top: 2px solid ${(props) => props.theme.colors.dark};
    width: 12px;
  }
`;

const ValueContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: #2b3d54;

  div {
    color: rgba(73, 80, 87, 0.4);
    margin-left: 3px;
  }
`;

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value ? (
      <ValueContainer>
        {value.toLocaleString('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        })}
        <div>HT</div>
      </ValueContainer>
    ) : (
      <EmptyValue>
        <div />
      </EmptyValue>
    )}
  </CellContainer>
);

export default Cell;
